import styled from "styled-components";

const Row = styled.div`
  display: flex;
  justify-content: space-between;

  @media (max-width: 575px) {
    flex-wrap: wrap;

    .social-link {
      width: 100%;
      margin-top: 20px;
      border-top: 1px solid #666;
      padding-top: 20px;
    }
  }
`;
export default Row;